import { IFaireMoney } from '@faire/web-api--source/indigofair/data/IFaireMoney';
import { IImage } from '@faire/web-api--source/indigofair/data/IImage';

export namespace IAbandonedBrandCartNudgeResponse {
  export enum BrandCartPromoState {
    BRAND_CART_PROMO_STATE_UNKNOWN = 'BRAND_CART_PROMO_STATE_UNKNOWN',
    NO_PROMO = 'NO_PROMO',
    SINGLE_PROMO = 'SINGLE_PROMO',
    MULTIPLE_PROMOS = 'MULTIPLE_PROMOS',
  }

  /**
   * Return an instance of IAbandonedBrandCartNudgeResponse with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IAbandonedBrandCartNudgeResponse>
  ): IAbandonedBrandCartNudgeResponse =>
    ({
      brand_cart_item_images: [],
      ...(partial ?? {}),
    }) as IAbandonedBrandCartNudgeResponse;
}

export interface IAbandonedBrandCartNudgeResponse {
  brand_token: string | undefined;
  brand_name: string | undefined;
  brand_cart_total: IFaireMoney | undefined;
  brand_minimum: IFaireMoney | undefined;
  amount_below_minimum: IFaireMoney | undefined;
  brand_cart_item_images: Array<IImage>;
  brand_cart_size: number | undefined;
  promotion_description: string | undefined;
  brand_avatar_image: IImage | undefined;
  show_insider_label: boolean | undefined;
  show_top_shop_badge: boolean | undefined;
  promo_state:
    | keyof typeof IAbandonedBrandCartNudgeResponse.BrandCartPromoState
    | undefined;
}
